// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cz2.cz2 .cz2__ai-modal .cz2__ai-modal__error{display:flex;flex-direction:column;align-items:center;gap:8px}#cz2.cz2 .cz2__ai-modal .cz2__modal-popup__copy--ai-centered{text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
